var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0CFCE",
    stroke: "none",
    d: "M44.1833,60.9583c0,4.9583,7.8401,7.0417,7.8401,7.0417H36.4029h-0.3795H20.4029 c0,0,7.8401-2.0833,7.8401-7.0417v-4.9336h15.7785L44.1833,60.9583z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9A",
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M63.1941,56H9.2323c-2.8026,0-5.0746-2.272-5.0746-5.0746V16.033c0-2.8026,2.272-5.0746,5.0746-5.0746h53.9618 c2.8026,0,5.0746,2.272,5.0746,5.0746v34.8924C68.2687,53.728,65.9967,56,63.1941,56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0CFCE",
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.9187,
    d: "M68.2687,47.5629c0,0,0.1688,4.8556-1.5499,6.8305s-0.7221,1.6035-3.5247,1.6035H9.2323c-2.8026,0-4.164-1.852-4.164-2.4434 l-0.9106-5.9906"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M63.1941,56H9.2323c-2.8026,0-5.0746-2.272-5.0746-5.0746V16.033c0-2.8026,2.272-5.0746,5.0746-5.0746h53.9618 c2.8026,0,5.0746,2.272,5.0746,5.0746v34.8924C68.2687,53.728,65.9967,56,63.1941,56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.9187,
    d: "M68.2687,47.5629c0,0,0.1688,4.8556-1.5499,6.8305s-0.7221,1.6035-3.5247,1.6035H9.2323c-2.8026,0-4.164-1.852-4.164-2.4434 l-0.9106-5.9906"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M63.1941,56H9.2323c-2.8026,0-5.0746-2.272-5.0746-5.0746V16.033c0-2.8026,2.272-5.0746,5.0746-5.0746h53.9618 c2.8026,0,5.0746,2.272,5.0746,5.0746v34.8924C68.2687,53.728,65.9967,56,63.1941,56z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.2132,
    x2: 65.2132,
    y1: 48.4924,
    y2: 48.4924,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M43.1833,60.9583c0,4.9583,8.8401,7.0417,8.8401,7.0417H36.4029h-0.3795H20.4029c0,0,8.8401-2.0833,8.8401-7.0417"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.58ca100baef2f188b06f686269b96de0.svg";
export { ForwardRef as ReactComponent };